export default __webpack_public_path__ + "static/media/download-white.3d761f23.svg";